import { z } from 'zod';
import { meetingSummary } from './meetings';
import { person } from './people';

export const searchQuery = z.object({ q: z.string().trim().min(2).max(100) });
export type SearchQuery = z.infer<typeof searchQuery>;

/** A meeting that matched, with the line that matched when one did. */
export const searchHit = meetingSummary.extend({ snippet: z.string().nullable() });
export type SearchHit = z.infer<typeof searchHit>;

export const searchResults = z.object({
  meetings: z.array(searchHit),
  people: z.array(person),
});
export type SearchResults = z.infer<typeof searchResults>;
